import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=3b33857c&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"
import style0 from "./couponList.vue?vue&type=style&index=0&id=3b33857c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33857c",
  null
  
)

component.options.__file = "src/demo/packageMall/couponList.vue"
export default component.exports